import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/vnv': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M104.9 352c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5s-10.4-18.1 10.4-18.1h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1c15.9 0 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5s-12.2 30.4-46.4 30.4h-35.1zM499.9 352c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5s-10.4-18.1 10.4-18.1h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1c15.9 0 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.9c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5s-12.2 30.4-46.4 30.4h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/vnv.js
// module id = 1085
// module chunks = 0